import AnalyticsUtil from 'utils/AnalyticsUtil';

export default {
    push(localizerKey) {
        AnalyticsUtil.push({
            event: 'track_event',
            category: 'Left Navigation Click Events',
            action: `User clicked ${localizerKey}`
        });
    }
};
